
const { kebabCase } = require('lodash')

module.exports = (name, color) => `
.${kebabCase(name)} {
    color: ${color};
}

`



// WEBPACK FOOTER //
// ./src/templates/component_scss.js